/**
 * NotificationBell — header icon button with unread badge; opens the drawer.
 *
 * Badge follows the NavItem convention: red count pill (9+ caps), polling
 * every 60s via useUnreadNotificationCount.
 */

import { useState } from 'react'
import { Bell } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useUnreadNotificationCount } from '../hooks/useNotifications'
import { NotificationDrawer } from './NotificationDrawer'

export function NotificationBell() {
  const [open, setOpen] = useState(false)
  const { unreadCount, setUnreadCount, refresh } = useUnreadNotificationCount()

  return (
    <>
      <Button
        variant="ghost"
        size="icon"
        className="relative"
        aria-label={unreadCount > 0 ? `Notifications (${unreadCount} unread)` : 'Notifications'}
        onClick={() => setOpen(true)}
      >
        <Bell className="h-5 w-5" />
        {unreadCount > 0 && (
          <span className="absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-red-500 px-1 text-[10px] font-semibold leading-none text-white">
            {unreadCount > 9 ? '9+' : unreadCount}
          </span>
        )}
      </Button>
      <NotificationDrawer
        open={open}
        onClose={() => {
          setOpen(false)
          refresh()
        }}
        onUnreadCountChange={setUnreadCount}
      />
    </>
  )
}
